import useMediaQuery from '@mui/material/useMediaQuery';

export function useIsLandscapeOrientation() {
  const isLandscapeOrientation = useMediaQuery(`(orientation: landscape)`);
  return isLandscapeOrientation;
}
